import { Box, Button, IconButton, InputBase, Pagination } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { TableMui } from "../../components/mui";
import { useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export default () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "RollingAdz: vehicle" || "Default Title";
  }, []);
  const data = [
    {
      vehicle_type: "SUV",
      "License Plate":"ghgh",
      year: "2007",
      make_model: "2000",
      route_type: "city",
      location: "texas",
      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Compact",
      "License Plate":"ghgh",
      year: "2004",
      make_model: "2001",
      route_type: "city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Sports Car",
      year: "2002",
      "License Plate":"ghgh",
      make_model: "2000",
      route_type: "Outer city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Truck",
      year: "2001",
      make_model: "2001",
      "License Plate":"ghgh",
      route_type: "city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Electric Car",
      year: "2010",
      "License Plate":"ghgh",
      make_model: "2001",
      route_type: "Outer city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Compact",
      year: "2004",
      make_model: "2000",
      "License Plate":"ghgh",
      route_type: "Outer city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Sports Car",
      year: "2002",
      make_model: "2001",
      route_type: "city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Truck",
      year: "2001",
      make_model: "2000",
      route_type: "Outer city",
      location: "texas",
      "License Plate":"ghgh",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Truck",
      year: "2006",
      make_model: "2001",
      route_type: "Outer city",
      location: "texas",

      owner: "test@gmail.com",
    },
    {
      vehicle_type: "Truck",
      year: "2006",
      make_model: "2001",
      route_type: "Outer city",
      location: "texas",

      owner: "test@gmail.com",
    },
    
    // ... Add more records ...
  ];
  return (
    <>
      <div
        className=" d-flex justify-content-between align-items-center px-4 col-md-6"
        style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
      >
        <InputBase
          className=""
          sx={{
            ml: 1,
            flex: 1,
            px: 1,
          }}
          placeholder="Search..."
          type="search"
        />
        <Box
          sx={{
            width: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <IconButton
            type="button"
            sx={{
              p: "5px",
              backgroundColor: "#3E4755",
              color: "white",
              "&:hover": {
                backgroundColor: "#3E4755",
                color: "white",
              },
            }}
            aria-label="search"
          >
            <Search style={{ fontSize: 25 }} />
          </IconButton>
        </Box>
      </div>
      <div className="d-flex justify-content-center">
        <h1 style={{ color: "black" }}>Vehicles</h1>
      </div>
      <div>
        <TableMui
          styleTableTh={{
            color: "black",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
          th={{
            vehicle_type: (
              <>
                Vehicle Type <FilterAltOutlinedIcon />
              </>
            ),

            year: (
              <>
                Year <FilterAltOutlinedIcon />
              </>
            ),
            make_model: (
              <>
                Make/Model <FilterAltOutlinedIcon />
              </>
            ),
            route_type: (
              <>
                Route Type <FilterAltOutlinedIcon />
              </>
            ),
            location: (
              <>
                Location <FilterAltOutlinedIcon />
              </>
            ),
            owner: (
              <>
                Owner <FilterAltOutlinedIcon />
              </>
            ),
            "License Plate": (
              <>
                 License Plate <FilterAltOutlinedIcon />
              </>
            ),
          }}
          td={data}

          customFields={[
            {
              name: "location",
              data: (value, item) => (
              
             <Link to={"/admin/adminLocation"}>texas</Link>    
                
              ),
            },
          ]}
        />
      </div>
      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
      </div>
    </>
  );
};
